enum IdentityConnectionProvider {
  GOOGLE = 'GOOGLE',
  MICROSOFT = 'MICROSOFT',
}

export default IdentityConnectionProvider;
